import {floatLength} from 'ceres/app/helper/number';
import {defaultValue} from 'ceres/app/helper/utils';
import Vue from 'vue';

Vue.directive('basket-item-quantity', {
    update(el, binding) {
        const value = defaultValue(binding.value, 0);
        const decimals = floatLength(value);

        if (value > 0) {
            el.innerHTML = '<span class="badge-right">' + value.toFixed(decimals).replace('.', App.decimalSeparator) + '</span>';
        } else {
            el.innerHTML = '';
        }
    }
});
